<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      :show-close="false"
      destroy-on-close
      width="450px"
      top="0vh"
      :close-on-click-modal="false"
    >
      <div class="box">
        <div class="box_title" v-if="IsLoginType === 1 || IsLoginType === 2">
          <span
            :class="[IsLoginType === 1 && 'LoginType']"
            @click="ClickLoginType(1)"
            >账密登录</span
          >
          <span></span>
          <span
            :class="[IsLoginType === 2 && 'LoginType']"
            @click="ClickLoginType(2)"
            >短信登录</span
          >
        </div>
        <div v-else class="box_title_v2">
          {{ IsLoginType === 3 ? '注册账号' : '找回密码' }}
        </div>
        <div>
          <el-input
            v-model.trim="parmas.mobile"
            :maxlength="11"
            placeholder="请输入手机号"
            @blur="mobileBlur"
            @keyup.enter.native="JumpTo"
          >
          </el-input>
          <div :class="['mobile_describe', mobileIpt && 'input_ative']">
            请输入正确的手机号
          </div>
        </div>
        <div v-if="IsLoginType === 1 || IsLoginType === 3">
          <el-input
            v-model.trim="parmas.password"
            :maxlength="11"
            placeholder="请输入密码"
            :type="passwordIconShow ? 'text' : 'password'"
            @blur="passwordBlur"
            @keyup.enter.native="JumpTo"
          >
            <img
              slot="suffix"
              style="
                width: 24px;
                height: 24px;
                margin-top: 8px;
                cursor: pointer;
              "
              :src="passwordIconShow ? passwordIcon : hidePasswordIcon"
              alt=""
              @click="handleIconClick"
          /></el-input>
          <div :class="['mobile_describe', passwordIpt && 'input_ative']">
            请输入10位数或字母组成的密码
          </div>
        </div>
        <div
          class="inputPasword"
          style="margin-bottom: 20px"
          v-if="IsLoginType !== 1"
        >
          <el-input
            v-model.trim="parmas.smsRegCode"
            class="inputText"
            placeholder="请输入验证码"
          ></el-input>
          <div class="inputBtn" @click="GetCode">
            {{ countdown }}
          </div>
        </div>
        <div class="inputPasword" v-if="IsLoginType === 4">
          <el-input
            :minlength="6"
            :maxlength="16"
            v-model="parmas.password"
            class="inputText"
            placeholder="请输入6~16位数字"
          ></el-input>
          <div @click="JumpTo()" class="inputBtn inputUpdate">完成</div>
        </div>
        <div
          v-if="IsLoginType !== 4"
          @click="JumpTo()"
          :class="[
            'box_btn',
            parmas.mobile.length > 0 &&
              parmas.password.length > 0 &&
              'box_btn_ative',
            IsLoginType !== 1 && 'box_btn_ative',
          ]"
        >
          {{ IsLoginType === 3 ? '注册' : '登录' }}
        </div>
        <div class="role_box" v-if="IsLoginType === 3">
          <div
            v-for="(item, index) in roleList"
            :key="index"
            @click="roleClick(index)"
            class="role_item"
          >
            <img :src="index === roleIndex ? selectV2 : NoSelectV2" alt="" />
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="address_box" v-if="roleIndex === 2">
          <span
            @click="addressClick(index)"
            :class="[addressIndex === index && 'address_ative']"
            v-for="(item, index) in addressList"
            :key="index"
            >{{ item.name }}</span
          >
        </div>
        <div
          style="display: flex; justify-content: space-between"
          v-if="roleIndex === 2"
        >
          <el-input
            style="flex: 1"
            v-model="parmas.supplement"
            placeholder="请输入审核建议"
          ></el-input>
        </div>
        <el-input
          v-if="roleIndex === 1"
          v-model.trim="parmas.identity"
          :maxlength="11"
          placeholder="请输入身份证"
        ></el-input>
        <el-input
          v-if="roleIndex === 1"
          v-model.trim="parmas.identityName"
          placeholder="请输入姓名"
        ></el-input>
        <div class="box_privacy" v-if="IsLoginType === 3">
          <img
            @click="selectFlag = !selectFlag"
            :src="selectFlag ? noSelect : select"
            alt=""
          />
          <span
            >我已浏览并接受<span style="color: #16ad4a"
              >《用户服务与隐私协议》</span
            ></span
          >
        </div>
        <div class="box_footer" v-if="IsLoginType === 1 || IsLoginType === 2">
          <span :class="[IsModify && 'Modify']" @click="ClickLoginType(3)"
            >注册账号</span
          >
          <span :class="[!IsModify && 'Modify']" @click="ClickLoginType(4)"
            >找回密码</span
          >
        </div>
        <img
          @click="closeClick(false)"
          class="closeIcon"
          src="@/assets/images/login/close.png"
          alt=""
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Login from '@/models/login'
import { IsPhoneAvailable } from '@/utils/filters'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      dialogFormVisible: false,
      parmas: {
        mobile: '',
        password: '',
        smsRegCode: '',
        tab: 1,
        validateStatus: 1,
        supplement: '',
        identity: '',
        identityName: ''
      },
      IsModify: true,
      // 1-账号密码；2-短信登录；3-注册账号；4-找回密码
      IsLoginType: 1,
      select: require('@/assets/images/login/select.png'),
      noSelect: require('@/assets/images/login/no_select.png'),
      selectV2: require('@/assets/images/login/select_v2.png'),
      NoSelectV2: require('@/assets/images/login/no_select_v2.png'),
      passwordIcon: require('@/assets/images/login/showpw.png'),
      hidePasswordIcon: require('@/assets/images/login/hidepw.png'),
      passwordIconShow: false,
      roleList: [
        { name: '普通用户' },
        { name: '服务商' }
        // { name: '外部服务商' }
      ],
      roleIndex: 0,
      addressList: [{ name: '个人' }, { name: '学校' }, { name: '旅行社' }],
      addressIndex: 0,
      selectFlag: false,
      countdown: '获取验证码',
      remainingTime: 30,
      intervalId: null,
      supplement: '',
      mobileIpt: false,
      passwordIpt: false
    }
  },
  methods: {
    mobileBlur() {
      if (IsPhoneAvailable(this.parmas.mobile)) {
        this.mobileIpt = false
      } else {
        this.mobileIpt = true
      }
    },
    passwordBlur() {
      if (this.parmas.password.length === 0) {
        this.passwordIpt = true
      } else {
        this.passwordIpt = false
      }
    },
    open(data, index) {
      this.dialogFormVisible = data
      if (index) {
        this.IsLoginType = index
      }
    },
    async JumpTo() {
      this.mobileBlur()
      this.passwordBlur()
      let res
      if (this.IsLoginType === 1 || this.IsLoginType === 2) {
        if (this.parmas.mobile.length === 0) {
          return
        }
        if (this.IsLoginType === 1 && this.parmas.password.length === 0) {
          return
        }
        if (this.IsLoginType === 2 && this.parmas.smsRegCode.length === 0) {
          return
        }
        this.parmas.loginType = this.IsLoginType
        res = await Login.swjjPcUserLogin(this.parmas)
        if (res.status === 200) {
          this.setToken(res.data)
          this.setGlobalVip(false)
          this.closeClick(false)
          this.$message({
            message: '登录成功！',
            type: 'success'
          })
          await this.GetSwjjUserInfo()
          location.reload()
        } else {
          this.$message.error(res.message)
        }
      } else if (this.IsLoginType === 3) {
        if (
          this.parmas.password.length > 0 &&
          this.parmas.smsRegCode.length > 0 &&
          this.parmas.mobile.length > 0
        ) {
          res = await Login.swjjPcUserRegister(this.parmas)
          if (res.status === 200) {
            this.closeClick(true)
            this.$message({
              message: '注册成功！',
              type: 'success'
            })
          }
        } else {
          this.$message.error('请将信息填完整')
        }
      } else {
        if (
          this.parmas.mobile.length !== 0 &&
          this.parmas.smsRegCode.length !== 0 &&
          this.parmas.password.length !== 0
        ) {
          if (
            this.parmas.password.length > 5 &&
            this.parmas.password.length < 17
          ) {
            res = await Login.resetUserPassword(this.parmas)
            if (res.status === 200) {
              this.$message({
                message: '修改成功！',
                type: 'success'
              })
              this.closeClick(true)
            } else {
              this.$message.error(res.message)
            }
            return
          } else {
            this.$message.error('输入6至16位的密码')
          }
        }
        this.$message.error('请将信息填完整')
      }
    },
    closeClick(flag = false) {
      this.dialogFormVisible = flag
      this.parmas = {
        mobile: '',
        password: '',
        smsRegCode: '',
        tab: 1,
        validateStatus: 1,
        supplement: ''
      }
      this.IsLoginType = 1
      this.roleIndex = 0
      this.addressIndex = 0
      this.selectFlag = false
      this.countdown = '获取验证码'
    },
    // 倒计时
    startCountdown() {
      if (this.intervalId) {
        return // 如果已经启动，则不再重复启动
      }
      this.countdown = `${this.remainingTime}秒`
      this.intervalId = setInterval(() => {
        this.remainingTime--
        this.countdown = `${this.remainingTime}秒`
        if (this.remainingTime <= 0) {
          clearInterval(this.intervalId)
          this.intervalId = null
          this.remainingTime = 30
          this.countdown = '获取验证码'
        }
      }, 1000)
    },
    // 短信发送
    async GetCode() {
      if (this.intervalId !== null) {
        return
      }
      if (IsPhoneAvailable(this.parmas.mobile)) {
        let types = this.IsLoginType === 3 ? 1 : this.IsLoginType === 4 ? 3 : 2
        let res = await Login.getLoginSmsCode(this.parmas.mobile, {
          type: types
        })
        if (res.status === 200) {
          this.$message({
            message: res.data.message,
            type: 'success'
          })
          this.startCountdown()
        } else {
          this.$message.error('短信发送失败～')
        }
      } else {
        this.$message.error('请输入正确的手机号码～')
      }
    },
    ClickLoginType(data) {
      if (data === 1 || data === 2) {
        this.password = ''
      }
      if (data === 3) {
        if (this.intervalId !== null) {
          clearInterval(this.intervalId)
        }
        this.intervalId = null
        this.remainingTime = 30
        this.countdown = '获取验证码'
      }
      this.IsLoginType = data
    },
    async GetSwjjUserInfo() {
      let res = await Login.SwjjUserInfo()
      if (res.status === 200) {
        this.setUserInfo(res.data)
      }
    },
    addressClick(data) {
      this.addressIndex = data
      this.parmas.validateStatus = data + 3
    },
    roleClick(data) {
      this.roleIndex = data
      this.parmas.validateStatus = data + 1
      this.parmas.tab = data + 1
    },
    handleIconClick() {
      this.passwordIconShow = !this.passwordIconShow
    },
    ...mapActions(['setToken', 'setGlobalVip', 'setUserInfo'])
  }
}
</script>
<style lang="less" scoped>
.box {
  position: relative;
  padding: 30px 45px;
  background-color: #fff;
  border-radius: 8px;
  .box_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #191919;
    padding: 0px 60px;
    margin-bottom: 20px;
    .LoginType {
      color: #16ad4a;
    }
    span:nth-child(2) {
      width: 1px;
      height: 19px;
      background-color: #979797;
    }
    span:last-child,
    span:first-child {
      cursor: pointer;
    }
  }
  .box_title_v2 {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 20px;
  }
  .mobile_describe {
    height: 20px;
    color: #fff;
    font-size: 12px;
    padding-top: 2px;
  }
  .input_ative {
    color: #f56c6c;
  }
  .box_btn {
    width: 100%;
    background-color: #a4adb3;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    text-align: center;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    margin-top: 10px;
  }
  .box_btn_ative {
    background-color: #16ad4a;
  }
  .box_footer {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #666666;
    margin-top: 30px;
    font-weight: 400;
    span {
      cursor: pointer;
    }
    .Modify {
      color: #16ad4a;
    }
  }
  .inputPasword {
    display: flex;
    align-items: flex-end;
    // margin-top: 20px;
    .inputBtn {
      width: 116px;
      margin-left: 14px;
      border: 1px solid #18ad4c;
      border-radius: 4px;
      height: 39px;
      font-size: 12px;
      color: #16ad4a;
      background-color: #fff;
      text-align: center;
      line-height: 37px;
      cursor: pointer;
    }
    .inputUpdate {
      color: #fff;
      background-color: #16ad4a;
    }
  }
  .role_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    .role_item {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
      span {
        font-size: 12px;
        color: #191919;
      }
    }
  }
  .address_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;
    span {
      display: inline-block;
      font-size: 13px;
      width: 80px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #666;
      border: 1px solid #666;
      border-radius: 4px;
      cursor: pointer;
    }
    .address_ative {
      border: 1px solid #16ad4a;
      color: #16ad4a;
    }
  }
  .box_privacy {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #999;
    cursor: pointer;
    margin-top: 16px;
    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
  }
  .closeIcon {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -50px;
    left: 50%;
    margin-left: -14px;
    cursor: pointer;
  }
  /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    // margin-top: 16px;
  }
}
/deep/ .el-dialog__wrapper {
  height: 100%;
  display: flex;
}
/deep/ .el-dialog {
  margin: auto !important;
  border-radius: 8px;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
/deep/ .el-dialog__body {
  padding: 0px;
  border-radius: 8px;
}
</style>
